import { createFileRoute } from "@tanstack/react-router";

import ProjectsList from "~/pages/RecordLabelling/ProjectsList";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute(
  "/_private/record-labelling-admin/projects/",
)({
  staticData: ROUTE_STATIC.recordLabellingAdmin,
  component: ProjectsList,
});
